<template>
  <div :class="$style.btn">
    <slot/>
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'Btn',
};
</script>
<style lang="scss"
       module>
@import "src/brand/brandColors.variables";

.btn {
  composes: standard from "src/brand/typography.scss";
  background-color: $blue;
  font-size: 1.2rem;
  font-weight: 700;
  color: $white;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18rem;
  height: 4.8rem;
  border-radius: 0.4rem;
  cursor: pointer;
}
</style>
